import React from "react"
import Image from "next/image"

type Props = {
  title: string
  children: any
}

const ContetImageSection: React.FC<Props> = ({ title, children }) => {
  return (
    <section className="section-py">
      <div className="container xl:container mx-auto">
        <div className="row grid lg:grid-cols-12 items-center	">
          <div className="lg:col-span-6">
            <div className="">
              <h2 className="mb-5 fw-700 fs-xl">
                {title}
              </h2>
            
              {children}
            </div>
          </div>
          <div className="lg:col-span-6 xl:col-span-5 xl:col-start-8">
            <div className="video-main relative">
              <div className="application-video-one">
                <Image
                  alt="img-scoial"
                  title="img-scoial"
                  height={514.449}
                  width={514.449}
                  src="/img/technology/img-scoial@2x.webp"
                  className="img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContetImageSection
